import { Box } from "@mui/joy";
import Grid from "@mui/joy/Grid";

interface ObjectColumnProps {
    primary?: boolean;
    forceBreak?: boolean;
    full?: boolean;
    children?: any;
}

export default function ObjectColumn({
    primary = false,
    forceBreak = false,
    full = false,
    sx = {},
    size = null,
    children = <></>,
    ...restProps
}:ObjectColumnProps) {

    const sizeProps = size ?? (full ? {xs: 12} : {xs: 12, md: 6, lg: true});

    if(forceBreak) {
        return <Box flex={'0 0 100%'} />
    }

    return (
        <Grid {...sizeProps} /*xs={12} md={6} lg*/ sx={{
            maxWidth: {
                lg: primary ? '25%' : '100%',
            },
            // forceBreak && ...{flex: '0 0 100%'},
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            // position: 'sticky',
            // top: 'calc(41px + 64px + 1rem)',
            '> * + *': {
                mt: 1,
            },
            //primary?3:4
            ...sx,
        }} {...restProps}>
            {children}
        </Grid>
    )
}
